import { h, createRef } from 'preact';
import  parse  from 'html-react-parser';

export default function Program(props) {

  const handleClick = (event) => {
    event.preventDefault();

    if(props.source === 'iframe') {
      const dialog = document.getElementById('io-program-finder-dialog');
      if(!dialog){return;}

      if(!dialog.attributes.open){
        dialog.showModal();
      } else {
        dialog.close();
      }
      return;
    }

    if(findAncestor(event.target, 'badge') === null){
      const anchor = event.target.closest("a");
      window.open(anchor.href, '_blank').focus();
    }
  };

  function findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  }

  let bodyText = '';
  if(props.programs.paragraph){
    const wordCount = 15;
    bodyText = parse(props.programs.paragraph
      .replace(/<\/li>/g, ', ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/  +/g, ' ')
      .replace(/,\s*$/, '.')
    )

    const split = bodyText.split(' ');

    if(split.length > wordCount) {
      bodyText = split.slice(0, wordCount).join(' ') + '...';
    }
  }

  const source = props.source || null;
  let url = props.programs.url ;
  if(source) {
    url += '?utm_source=' + source;
  }

  return (
    <li class="finder__io-program">
      <a href={url} target="_blank" onClick={handleClick}>
        <div className="program-card-wrapper">
          <div className="program-image">
            <img
              alt={props.programs.name}
              height="400"
              width="600"
              loading="lazy"
              src={
                props.programs.imageUrl ? props.programs.imageUrl : ""
              } />
          </div>
          <div className="program-header">
            <h3>{Drupal.t(props.programs.name)}</h3>
            <span className='program-instructor'>
              {props.programs.instructorName
               ? props.programs.instructorName
               : (props.programs.facultyInfo && props.programs.type == 'private' ? Drupal.t('Various Instructors') : '') }
            </span>
          </div>
          <div className="program-body">
            <p className="finder__content__paragraph">
              {Drupal.t(bodyText)}
            </p>
          </div>
          <div className="program-footer">
            <div className="program-details">
              <div className="program-details__type">
                {Drupal.t(props.programs.type_human)}
              </div>
              <div className="program-details__fee">
                {props.programs.fee.includes("$") ? props.programs.fee : `$${props.programs.fee}`}
              </div>
              <div className="program-badges">
                {props.programs.type_human == 'Certificate Program' ?
                  <button className="cert-badge badge tooltip">
                    <span className='badge-icon seal'><img loading="lazy" class='badge-image' src="/themes/interlochen/dist/img/seal-white.png" /></span>
                    <span className='text'>{Drupal.t("Certificate Program")}</span>
                    <div className="tooltiptext tooltip-bottom" role="tooltip">
                      {Drupal.t("Earn college and/or high school credit when completing:")}
                      <ul className="cert-list">
                        {props.programs.certCourses.map((ele, idx) => (
                          <li className="cert-item" key={idx}>{Drupal.t(ele.name)}</li>
                        ))}
                      </ul>
                    </div>
                  </button >
                  : ''}
                {props.programs.certificateGroups ? (
                  <button className="tooltip badge contrib-badge">
                    <span className='badge-icon contrib'><img loading="lazy" class='badge-image' src="/themes/interlochen/dist/img/certificate_steps_white.png" /></span>
                    <span className='text'>{Drupal.t("Counts Towards a Certificate")}</span>
                    <div className='tooltiptext tooltip-bottom' role='tooltip'>
                      {Drupal.t("This course can be applied to the following certificate program(s):")}
                      <ul className="cert-list">
                        {props.programs.certificateGroups.map((certificate, index) => (
                          <li className="cert-item" key={index}>{Drupal.t(certificate.name)}</li>
                        ))}
                      </ul>
                    </div>
                  </button>
                ) : ''}
                {props.programs.popularity > 0 ? (
                  <div className="tooltip badge popular-badge">
                    <span className='badge-icon popular'>❤&#xFE0E; &nbsp;</span>
                    <span className='text'>{Drupal.t("Popular")}</span>
                  </div>
                ) : ''}
                {props.programs.newProgram == true ? (
                  <div className="tooltip badge new-badge">
                    <span className='badge-icon new'>✦&#xFE0E; &nbsp;</span>
                    <span className='text'>{Drupal.t("New")}</span>
                  </div>
                ) : ''}


              </div>
            </div>

          </div>
        </div>
      </a>
    </li>
  )
}
